import { Component, ViewChildren, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { Router, NavigationEnd } from '@angular/router';

import { Observable } from 'rxjs';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { SwalComponent } from '@toverux/ngx-sweetalert2';

import {
    ScriptLoaderService
} from '../../../../../_services';
import {
    Unit, UnitMonthlyCut, UnitMonthlyCutProviders
} from '../../../../../_models';
import { Unit as C } from '../../../../../_models/Classes';
import { DatePickerComponent } from './../../../../../shared/date-picker';
import { LiveSearchSelectComponent } from './../../../../../shared/live-search-select';
import { InsuranceComponent } from '../insurance';
import { ContractComponent } from '../contract';
const UNIT_INCLUDES = `investor,property,warehouses,parking_spaces,photos`;

@Component({
    selector: 'app-unit-detail',
    templateUrl: './unit-detail.component.html',
    styleUrls: ['./unit-detail.component.scss'],
    providers: [UnitMonthlyCutProviders]
})
export class UnitDetailComponent {
    @ViewChild(InsuranceComponent) insurance: InsuranceComponent;
    @ViewChild(ContractComponent) contract: ContractComponent;
    photos = [];
    unitId: number;
    header = {
        icon: '',
        text: ''
    };
    params = '';
    unit = this.unitData.make({});
    dataFetched: boolean = false;
    constructor(
        private _domSanitizer: DomSanitizer,
        private _route: ActivatedRoute,
        private _script: ScriptLoaderService,
        private _router: Router,
        private unitData: Unit,
        private unitMonthlyCutData: UnitMonthlyCut
    ) {
        this.unitData.sanitizer = _domSanitizer;
        this.unitId = this._route.snapshot.params['id'];
        this.unitMonthlyCutData.getUnitMonthlyCuts(this.unitId).subscribe(monthlyCuts => { });
        this.dataFetched = false;
        this.unitData.get(this.unitId, `include=${UNIT_INCLUDES}`).subscribe((unit: C) => {
            this.unit = unit;
            this.header.text = `Unidad ${unit.name}`;
            this.dataFetched = true;
        });
        this._router.events.subscribe((route) => {
            if (route instanceof NavigationEnd) {
                this.refreshImages();
            }
        });
    }

    refreshImages() {
        this.unitData.getFiles(this.unitId).subscribe(photos => { this.photos = photos; });
    }
    tabChanged(tab) {
        switch (tab.id) {
            case 'contrato':
                this.contract.getData();
                break;
            case 'seguro':
                this.insurance.getData();
                break;
        }
    }
}



// WEBPACK FOOTER //
// /Users/cmedina/Code/motto_frontend/src/app/theme/pages/aside-left-display-disabled/units/unit-detail/unit-detail.component.ts